import React from 'react';
import { Device } from '../../types';
import SensorPanels from '../SensorPanels';

interface BuoyDetailsProps {
  device: Device;
  deviceId: string;
}

const BuoyDetails: React.FC<BuoyDetailsProps> = ({ device }) => {
  return <SensorPanels device={device} />;
};

export default BuoyDetails;

